import { useContext } from "react";
import { DurationDistance } from "~/generated/graphql.types";
import { EditModeContext, ViewMode } from "../../../..";
import { SpotStatEntity } from "./SpotStatEntity";
import { SpotStatDummy } from "./SpotStatDummy";
import { Divider } from "@chakra-ui/react";

export const SpotStatInterface = ({
  stat,
  hasLeftMargin,
}: {
  stat: DurationDistance | undefined | null;
  hasLeftMargin: boolean;
}) => {
  const { viewMode } = useContext(EditModeContext);

  if (viewMode === ViewMode.voiceView) {
    return <Divider orientation="vertical" mx={4} borderStyle="dotted" h={3} />;
  } else if (stat === undefined || stat === null) {
    return <SpotStatDummy hasLeftMargin={hasLeftMargin} />;
  } else {
    return <SpotStatEntity stat={stat} hasLeftMargin={hasLeftMargin} />;
  }
};
